import { Box, Tab, Typography, styled } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { TabContext, TabList } from '@mui/lab';
import { useLocation, useNavigate, useParams } from 'react-router';
import Image from '../../components/Image';
import palette from '../../theme/palette';
import useLocales from '../../hooks/useLocales';
import { useSelector } from '../../redux/store';
import Iconify from '../../components/Iconify';
import { getGameCategIcon } from '../../utils/formatObject';

const SubHeaderContainer = styled(Box)(() => ({
  boxShadow: '0px 1px 5px 5px rgb(0, 0, 0, 0.2)',
  height: '3rem',
  background: palette.navBarVertical.subBg,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'start',
  paddingRight: '.5rem',
  paddingLeft: '.5rem',
  overflow: 'hidden',
  width: '100%',
}));

const SubHeaderNav = () => {
  const { translate } = useLocales();

  const { gameCategsAndCompanies } = useSelector((x) => ({ ...x.game, ...x.lookup }));

  const [activeSubTab, setActiveSubTab] = useState('lobby');

  const navigate = useNavigate();

  const params = useParams();

  const navButtons = useMemo(() => {
    const _navButtons = [
      {
        title: translate('home'),
        value: 'lobby',
        imageSrc: { src: require('../../assets/home/nav-home.png') },
        action: () => {
          setActiveSubTab('lobby');
          navigate('/home');
        },
      },
      // {
      //   title: translate('VIP Club'),
      //   value: 'vip',
      //   imageSrc: { src: require('../../assets/menu/nav-vip.png') },
      //   action: () => {
      //     if (!isAuthenticated) dispatch(openLoginSignup({ open: true, isLogin: true }));
      //     else {
      //       setActiveSubTab('vip');
      //       navigate('/vip');
      //     }
      //   },
      // },
    ];

    if (gameCategsAndCompanies?.length) {
      gameCategsAndCompanies.forEach((categ) => {
        _navButtons.push({
          title: categ?.name,
          value: categ?.slug,
          imageSrc: getGameCategIcon(categ?.slug),
          action: () => onCategClick(categ?.slug),
        });
      });
    }

    return _navButtons;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gameCategsAndCompanies]);

  useEffect(() => {
    if (params?.categSlug) {
      setActiveSubTab(params?.categSlug);
    }
  }, [params]);

  // useEffect(() => {
  //   if (location.pathname === '/vip') {
  //     setActiveSubTab('vip');
  //   }
  // }, [location]);

  const onCategClick = (slug) => {
    setActiveSubTab(slug);
    navigate(`/games/${slug}`);
  };

  return (
    <SubHeaderContainer>
      <Box
        sx={{
          width: '100%',
          overflow: 'hidden',
          '.MuiTabs-flexContainer': {
            marginLeft: '10px !important',
            marginRight: '10px !important',
          },
        }}
      >
        <TabContext value={activeSubTab}>
          <Box sx={{ borderBottom: 0, width: '100%', display: 'flex', justifyContent: 'start' }}>
            <TabList
              TabIndicatorProps={{
                style: {
                  backgroundColor: 'rgb(255, 77, 77)',
                  boxShadow: 'rgb(203, 51, 33) 0px -4px 9px 0px',
                  height: '0.2rem',
                },
              }}
              sx={{
                minHeight: 'unset',
                color: 'white',
                flex: { xs: 1, sm: 1, md: 'none' },
                maxWidth: { xs: '100%', sm: '100%', md: '80%' },
                '& .MuiTabs-flexContainer': {
                  display: { xs: 'flex', sm: 'flex', md: 'inline-block' },
                },
              }}
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              TabScrollButtonProps={{
                sx: {
                  width: '0.5rem',
                  borderRadius: 0,
                },
              }}
            >
              {navButtons.map((nav, idx) => (
                <Tab
                  key={idx}
                  sx={{
                    justifyContent: 'center',
                    marginRight: idx !== navButtons.length - 1 ? '0.7rem !important' : 0,
                    background:
                      activeSubTab === nav.value
                        ? 'radial-gradient(164.23% 100% at 50% 0%, rgba(35, 38, 44, 0) 0%, rgba(114, 125, 146, 0.11) 100%)'
                        : 'transparent',
                    // boxShadow: activeSubTab === nav.value ? '0px 0px 8px 0px #FFD633' : 'transparent',
                    // border: activeSubTab === nav.value ? '1px solid #FFF1B9' : 'none',
                    cursor: 'pointer',
                    minHeight: 'unset',
                    minWidth: 'unset',
                    flex: 1,
                    borderRadius: '8px',
                    py: '5px',
                    overflow: 'inherit',
                  }}
                  onClick={nav.action}
                  label={
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        height: '100%',
                        minWidth: '60px',
                        flex: 1,
                        gap: 1,
                        mx: 1,
                      }}
                    >
                      <Box
                        sx={{
                          flexGrow: 1,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          margin: '5px 0 2px 0',
                          flex: 1,
                        }}
                      >
                        {nav.imageSrc?.src ? (
                          <Box sx={{ width: 25, height: 25, display: 'flex', alignItems: 'center' }}>
                            <Image src={nav.imageSrc.src} sx={{ width: '100%', height: 'auto' }} />
                          </Box>
                        ) : (
                          <Iconify icon={nav.imageSrc?.icon} sx={{ width: 25, height: 25 }} />
                        )}
                      </Box>
                      <Typography
                        fontSize={{ xs: '0.8rem', sm: '0.8rem', md: '0.9rem' }}
                        fontWeight={900}
                        sx={{
                          whiteSpace: 'nowrap',
                          width: '100%',
                          marginLeft: nav.value === 'slots' ? '-3px' : 0,
                          mt: '2px',
                        }}
                      >
                        {nav.title}
                      </Typography>
                    </Box>
                  }
                  value={nav.value}
                />
              ))}
            </TabList>
          </Box>
        </TabContext>
      </Box>
    </SubHeaderContainer>
  );
};

export default SubHeaderNav;
